import {
  Download,
  GripHorizontal,
  History,
  LayoutDashboard,
  LucideIcon,
  Settings2,
  ShieldCheck,
  Upload,
  User,
} from 'lucide-react'

type AccountLinkKey = 'index' | 'security' | 'settings' | 'more'
type LinkItem = {
  href: string
  Icon: LucideIcon
}

export const ACCOUNT_LINKS: Record<AccountLinkKey, LinkItem> = {
  index: {
    href: '/account',
    Icon: User,
  },
  security: {
    href: '/account/security',
    Icon: ShieldCheck,
  },
  settings: {
    href: '/account/settings',
    Icon: Settings2,
  },
  more: {
    href: '/account/more',
    Icon: GripHorizontal,
  },
}

type PortfolioLinkKey = 'index' | 'deposit' | 'withdraw' | 'history'

export const PORTFOLIO_LINKS: Record<PortfolioLinkKey, LinkItem> = {
  index: {
    href: '/portfolio',
    Icon: LayoutDashboard,
  },
  deposit: {
    href: '/portfolio/deposit',
    Icon: Download,
  },
  withdraw: {
    href: '/portfolio/withdraw',
    Icon: Upload,
  },
  history: {
    href: '/portfolio/transaction-history',
    Icon: History,
  },
}
